export default __webpack_public_path__ + "static/media/dots-grid.ecb75be5.svg";